import { addToCart } from '~/js/lib/cart'; // eslint-disable-line
import { formatMoney, ensureGlobalShopifyFormat } from '../utils/money';
import {
  cartDrawerCloseGeneration,
  requestCartDrawerOpen,
} from '../utils/util-functions';

// Ensure legacy global (Shopify.formatMoney) exists for any other scripts relying on it.
ensureGlobalShopifyFormat();

export default (node) => {
  const slider_one = node.querySelector('[data-embla="1"]');
  const slider_two = node.querySelector('[data-embla="2"]');
  let slider_one_products = null;
  let slider_two_products = null;
  const shopCurrency = node.dataset.shopCurrency;
  const moneyFormat = node
    .getAttribute('data-money-format')
    .replace('amount_with_dot_separator', 'amount');

  const topImage = node.querySelector('[data-top-image] img');
  const bottomImage = node.querySelector('[data-bottom-image] img');
  const allTabs = node.querySelectorAll('[data-tab]');
  const allSlides = node.querySelectorAll('[data-lighting-product]');
  const collectionOneProductUrl = node.querySelector(
    '[data-collection-1-product-url]'
  );
  const collectionTwoProductUrl = node.querySelector(
    '[data-collection-2-product-url]'
  );
  const quantity = node.querySelector('[data-quantity]');
  const decreaseQuantityButton = node.querySelector('[data-decrease-quantity]');
  const increaseQuantityButton = node.querySelector('[data-increase-quantity]');

  const buttonGoToProduct = node.querySelector('[data-lighting-go-to-product]');

  const addToCartButton = node.querySelector('[data-lighting-add-to-cart]');
  const loadingText = node.getAttribute('data-loading-text');
  const addToCartText = node.getAttribute('data-add-to-cart-text');

  let currentSlideOne = 0;
  let currentSlideTwo = 0;

  const handleQuantityChange = (change) => {
    const currentValue = parseInt(quantity.value);
    if (change === 'increase') {
      return (quantity.value = currentValue + 1);
    }

    quantity.value = currentValue - 1 <= 0 ? 1 : currentValue - 1;
  };

  const firstLoad = () => {
    // select the first slide from each slider
    const firstImage = slider_one_products[0].getAttribute(
      'data-lighting-product-image'
    );
    const secondImage = slider_two_products[0].getAttribute(
      'data-lighting-product-image'
    );
    // update the images
    topImage.src = firstImage;
    bottomImage.src = secondImage;

    setTimeout(() => {
      topImage.classList.remove('hidden');
      bottomImage.classList.remove('hidden');
    }, 300);

    // auto select the first product for each slider and update the url
    slider_one_products[0].classList.add(
      'border-b-black',
      'border-solid',
      'border-b'
    );
    currentSlideOne = slider_one_products[0].getAttribute(
      'data-lighting-product'
    );
    const firstUrl = slider_one_products[0].getAttribute(
      'data-slide-product-url'
    );
    collectionOneProductUrl.href = firstUrl;

    slider_two_products[0].classList.add(
      'border-b-black',
      'border-solid',
      'border-b'
    );
    currentSlideTwo = slider_two_products[0].getAttribute(
      'data-lighting-product'
    );
    const secondUrl = slider_two_products[0].getAttribute(
      'data-slide-product-url'
    );
    collectionTwoProductUrl.href = secondUrl;

    updatePrices();
    updateTitles();
  };

  const handleSlideClick = (e) => {
    const slide = e.currentTarget;
    const sliderNumber = slide.getAttribute('data-slider-number');

    let previousSlide = null;
    // remove previous selected slide
    if (sliderNumber === '1') {
      previousSlide = slider_one.querySelector(
        `[data-lighting-product="${currentSlideOne}"]`
      );
      // update the current slide
      currentSlideOne = slide.getAttribute('data-lighting-product');
      // update the url
      collectionOneProductUrl.href = slide.getAttribute(
        'data-slide-product-url'
      );
    } else {
      previousSlide = slider_two.querySelector(
        `[data-lighting-product="${currentSlideTwo}"]`
      );
      // update the current slide
      currentSlideTwo = slide.getAttribute('data-lighting-product');
      // update the url
      collectionTwoProductUrl.href = slide.getAttribute(
        'data-slide-product-url'
      );
    }
    // update the images
    if (sliderNumber === '1') {
      topImage.src = slide.getAttribute('data-lighting-product-image');
    } else {
      bottomImage.src = slide.getAttribute('data-lighting-product-image');
    }

    slide.classList.add('border-b-black', 'border-solid', 'border-b');
    previousSlide.classList.remove(
      'border-b-black',
      'border-solid',
      'border-b'
    );

    updatePrices();
    updateTitles();
  };

  const updateTitles = () => {
    const slideProductOne = slider_one.querySelector(
      `[data-lighting-product="${currentSlideOne}"]`
    );
    const slideProductTwo = slider_two.querySelector(
      `[data-lighting-product="${currentSlideTwo}"]`
    );
    node.querySelector('[data-collection-1-product-title]').textContent =
      slideProductOne.dataset.slideProductTitle;
    node.querySelector('[data-collection-2-product-title]').textContent =
      slideProductTwo.dataset.slideProductTitle;
  };

  const updatePrices = () => {
    // update the price and compare at price
    const slideProductOne = slider_one.querySelector(
      `[data-lighting-product="${currentSlideOne}"]`
    );
    const slideProductTwo = slider_two.querySelector(
      `[data-lighting-product="${currentSlideTwo}"]`
    );
    let currentPrice =
      Number(slideProductOne.dataset.slideProductPrice) +
      Number(slideProductTwo.dataset.slideProductPrice);
    let currentCompareAtPrice =
      Number(slideProductOne.dataset.slideCompareAtPrice) +
      Number(slideProductTwo.dataset.slideCompareAtPrice);
    node.querySelector('[data-products-price]').textContent = formatMoney(
      currentPrice,
      moneyFormat
    );
    node.querySelector('[data-products-compare-price]').textContent =
      formatMoney(currentCompareAtPrice, moneyFormat);
    if (currentCompareAtPrice == 0) {
      node
        .querySelector('[data-products-compare-price]')
        .classList.add('hidden');
    } else {
      node
        .querySelector('[data-products-compare-price]')
        .classList.remove('hidden');
    }
  };

  const handleTabClick = (e) => {
    const tab = e.currentTarget;
    const tabNumber = tab.getAttribute('data-tab');
    node
      .querySelector(`[data-tab="${tabNumber}"]`)
      .classList.add(
        'border-b-black',
        'border-solid',
        'border-b',
        'font-medium'
      );
    node
      .querySelector(`[data-tab="${tabNumber === '1' ? '2' : '1'}"]`)
      .classList.remove(
        'border-b-black',
        'border-solid',
        'border-b',
        'font-medium'
      );
    // Immediate swap without animations
    const otherNumber = tabNumber === '1' ? '2' : '1';
    const currentDesc = node.querySelector(
      `[data-collection-${tabNumber}-product-description]`
    );
    const otherDesc = node.querySelector(
      `[data-collection-${otherNumber}-product-description]`
    );
    const currentUrl = node.querySelector(
      `[data-collection-${tabNumber}-product-url]`
    );
    const otherUrl = node.querySelector(
      `[data-collection-${otherNumber}-product-url]`
    );

    if (otherDesc) otherDesc.classList.add('hidden');
    if (currentDesc) currentDesc.classList.remove('hidden');
    if (otherUrl) otherUrl.classList.add('hidden');
    if (currentUrl) currentUrl.classList.remove('hidden');
  };

  const handleAddToCart = async () => {
    // get the quantity
    const quantity = node.querySelector('[data-quantity]');
    const slideProductOne = slider_one.querySelector(
      `[data-lighting-product="${currentSlideOne}"]`
    );
    const slideProductTwo = slider_two.querySelector(
      `[data-lighting-product="${currentSlideTwo}"]`
    );
    // get the 2 variant ids
    const variantIdOne = slideProductOne.getAttribute('data-slide-variant-id');
    const variantIdTwo = slideProductTwo.getAttribute('data-slide-variant-id');
    // add to cart
    const items = [
      {
        id: Number(variantIdOne),
        quantity: quantity ? parseInt(quantity.value) : 1,
      },
      {
        id: Number(variantIdTwo),
        quantity: quantity ? parseInt(quantity.value) : 1,
      },
    ];

    addToCartButton.textContent = loadingText;
    addToCartButton.disabled = true;
    // Snapshot before the async add so a late reopen can't override a user close.
    const closeGenerationBefore = cartDrawerCloseGeneration();
    await addToCart(items);
    addToCartButton.textContent = addToCartText;
    addToCartButton.disabled = false;
    // reset the quantity
    quantity.value = 1;

    dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: shopCurrency,
        add: {
          products: [
            {
              name: slideProductOne.getAttribute('data-slide-product-title'),
              id: variantIdOne,
              price:
                slideProductOne.getAttribute('data-slide-product-price') / 100,
              quantity: quantity ? parseInt(quantity.value) : 1,
            },
          ],
        },
      },
    });

    // Emit event to open cart (unless the user closed the drawer during the add)
    requestCartDrawerOpen(closeGenerationBefore);
  };

  const init = () => {
    if (slider_one && slider_two) {
      slider_one_products = slider_one.querySelectorAll(
        '[data-lighting-product]'
      );
      slider_two_products = slider_two.querySelectorAll(
        '[data-lighting-product]'
      );

      firstLoad();

      allSlides.forEach((slide) => {
        slide.addEventListener('click', handleSlideClick);
      });

      allTabs.forEach((tab) => {
        tab.addEventListener('click', handleTabClick);
      });
    }
    // Initialize event listeners
    if (decreaseQuantityButton) {
      decreaseQuantityButton.addEventListener('click', () =>
        handleQuantityChange('decrease')
      );
    }

    if (increaseQuantityButton) {
      increaseQuantityButton.addEventListener('click', () =>
        handleQuantityChange('increase')
      );
    }

    if (addToCartButton) {
      addToCartButton.addEventListener('click', handleAddToCart);
    }

    if (buttonGoToProduct) {
      // scroll to the top of the page
      buttonGoToProduct.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    }
  };

  init();
};
